import * as React            from 'react';
import {cs}                  from '@Common/react/chain-services';

import {GoogleLogin}         from '@react-oauth/google';
import {GoogleOAuthProvider} from '@react-oauth/google';

import {ReactGAGuestEvent}   from '@Common/libs/ga/xd-react-ga';
import {consumeContext}      from '@Common/react/context';
import {scopedState}         from '@Common/react/scoped-state';
import {scrollIntoView}      from '@Common/ui-components/light/scroll-into-view';

export const GoogleLoginButton = ({content, apiError, domRef, onSuccess = null, onError = null}) => cs(
    consumeContext("apis"),
    consumeContext("systemConstants"),
    consumeContext("themeScheme"),
    ({apis, systemConstants, themeScheme}) => (
        <GoogleOAuthProvider clientId={systemConstants?.value?.GOOGLE_CLIENT_ID}>
            <GoogleLogin
                onSuccess={(credentialResponse) => {
                    if (onSuccess) return onSuccess(credentialResponse); // use override for custom onSuccess if provided
                    scopedState(content, ["loading"]).onChange(true);
                    handleLogin(content, credentialResponse, apis, apiError, domRef, themeScheme);
                }}
                onError={() => {
                    if (onError) return onError(); // use override for custom onError if provided
                    scopedState(content, ["loading"]).onChange(false);
                    console.log('Login Failed')
                }}
                text="continue_with"
                logo_alignment="center"
                width="400"
                useOneTap={false}
            />
        </GoogleOAuthProvider>
    )
)

const handleLogin = async (content, credentialResponse, apis, apiError, domRef, themeScheme) => {
    try {
        var token = credentialResponse.credential
        let data = await apis.next.authenticate.googleLogin({
            token
        })
        data.statusCode === "success" ? (
            ReactGAGuestEvent({
                eventName: "login",
                method: "Google",
                reason: data.message,
                statusCode: data.statusCode
            }),
            themeScheme?.enableGuestCheckout
            ? location.reload()
            : location.replace("/app")
        ) : (
            ReactGAGuestEvent({
                eventName: "login_failed",
                method: "Google",
                reason: data.message,
                statusCode: data.statusCode
            }),
            apiError.onChange(data),
            data?.data?.idUser && scopedState(content, ["content"]).onChange("signin"),
            scopedState(content, ["loading"]).onChange(false),
            scrollIntoView(domRef.get())
        )
    } catch (error) {
        scopedState(content, ["loading"]).onChange(false);
        console.error(error);
    }
}